import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  UtilityApiResponse,
  ScheduleApiResponse,
  EnergyApiResponse,
  getUtilityData,
  getScheduleData,
  getEnergyData,
} from "./commonAction";

interface CommonState {
  utilities: UtilityApiResponse["data"] | null;
  schedule: ScheduleApiResponse["data"] | null;
  energyData: EnergyApiResponse["data"] | null;
  loading: boolean;
  error: string | null;
}

const initialState: CommonState = {
  utilities: null,
  schedule: null,
  energyData: null,
  loading: false,
  error: null,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    resetCommonState: (state) => {
      state.utilities = null;
      state.schedule = null;
      state.energyData = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getUtilityData
      .addCase(getUtilityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getUtilityData.fulfilled,
        (state, action: PayloadAction<UtilityApiResponse>) => {
          state.loading = false;
          state.utilities = action.payload.data || null;
          state.error = null;
        }
      )
      .addCase(
        getUtilityData.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to retrieve utility data";
        }
      )
      // Handle getScheduleData
      .addCase(getScheduleData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getScheduleData.fulfilled,
        (state, action: PayloadAction<ScheduleApiResponse>) => {
          state.loading = false;
          state.schedule = action.payload.data || null;
          state.error = null;
        }
      )
      .addCase(
        getScheduleData.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to retrieve schedule data";
        }
      )
      // Handle getEnergyData
      .addCase(getEnergyData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getEnergyData.fulfilled,
        (state, action: PayloadAction<EnergyApiResponse>) => {
          state.loading = false;
          state.energyData = action.payload.data || null;
          state.error = null;
        }
      )
      .addCase(
        getEnergyData.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to retrieve energy data";
        }
      );
  },
});

export const { resetCommonState } = commonSlice.actions;
export default commonSlice.reducer;
